// extracted by mini-css-extract-plugin
export default {"breadcrumbs":"Breadcrumbs_breadcrumbs__UYyA4","breadcrumb":"Breadcrumbs_breadcrumb__yv-JD","link":"Breadcrumbs_link__FtpGb","icon":"Breadcrumbs_icon__vt34l"};